// extracted by mini-css-extract-plugin
export var button = "_dm-7";
export var buttonRow = "_dm-6";
export var fadeIn = "_dm-1";
export var gradient = "_dm-0";
export var panel = "_dm-2";
export var panelIn = "_dm-3";
export var subtitle = "_dm-5";
export var title = "_dm-4";